import vsf, { definePage } from '@vs/vsf-boot';
import { Page } from '@vs/vsf-kit';
import React from 'react';

const TagManage = (props) => {
  return <Page title="TagManage"></Page>;
};

export default definePage(TagManage);
